// extracted by mini-css-extract-plugin
export default {"leftwrap":"faceClick_leftwrap__HDW6K","handImg":"faceClick_handImg__XQ9iZ","guideText":"faceClick_guideText__jdklG","linkText":"faceClick_linkText__Me7FQ"};